type Props = {
  isLoading: boolean;
  message: string;
};
const MyLoader = ({ isLoading, message }: Props) => {
  return (
    <>
      {isLoading && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 overflow-y-hidden">
          <div className="py-3 px-20 bg-zinc-400 text-black rounded-lg flex items-center">
            <i className="fas fa-spinner fa-spin mr-2 "></i>
            {message}
          </div>
        </div>
      )}
    </>
  );
};

export default MyLoader;
